export const SHIPPING_LABELS_VIEW_HOME = 'list';
export const SHIPPING_LABELS_VIEW_DETAIL = 'detail';
export const SHIPPING_LABELS_VIEW_BATCH = 'batch';
// Split shipping-labels redesign: the home (SHIPPING_LABELS_VIEW_HOME) chooser opens one of two
// category sub-screens. Classification (instant vs physical) is server-side —
// the FE only passes the category to the list endpoints.
export const SHIPPING_LABELS_VIEW_INSTANT = 'instant';
export const SHIPPING_LABELS_VIEW_REGULAR = 'regular';

// Query-param key that deep-links the panel straight to a sub-screen, e.g.
// `/take-back-bags?view=instant` (order confirmation → Instant carousel). Its
// value is SHIPPING_LABELS_VIEW_INSTANT | SHIPPING_LABELS_VIEW_REGULAR.
export const SHIPPING_LABELS_VIEW_PARAM = 'view';

// Backend `category` query param values for the split list endpoints.
export const CATEGORY_INSTANT = 'instant';
export const CATEGORY_PHYSICAL = 'physical';
